import React, { PureComponent } from 'react'
import { DemandbaseAudiences } from 'constants/DemandbaseAudiences'

import SelectFilter from '../SelectFilter'

class DemandbaseAudienceFilter extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      options: DemandbaseAudiences
    }
  }

  render() {
    const { options } = this.state
    const { onUpdateCondition, activeFilter } = this.props
  
    return (
      <SelectFilter options={options} onUpdateCondition={onUpdateCondition} activeFilter={activeFilter}/>
    )
  }
}

export default DemandbaseAudienceFilter


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/Demandbase/DemandbaseAudienceFilter.js